import { PhonemeInfo } from "../pattern/phonemeInfo";
import { IpaType, getFeaturesForOne, isStress, primaryStress } from "../phonemes/ipa";
import { findSyllables } from "../phonotactics/findSyllables";
import { SyllablePhonotactics } from "../phonotactics/phonotactics";
import { findStressSyllable } from "./findStressSyllable";
import { StressRule } from "./stressRule";

/** add stress to the proper syllable based on the rules */
export function applyStressRule(
  word: IpaType[],
  rule: StressRule<PhonemeInfo>,
  phonotactics: SyllablePhonotactics<PhonemeInfo> | IpaType[],
): IpaType[] | false {
  if (word.some(p => isStress(p[0]))) {
    // already has a stress marker
    return rule.move ? moveStress(word, rule.move) : word;
  }

  // first break the word into syllables, failing if it doesn't match the phonotactics
  const syllables = findSyllables(word, phonotactics);
  if (syllables === false) {
    return false;
  }

  // then find which syllable should be stressed
  const which = findStressSyllable(word, rule);
  if (which === 0) {
    return word;  // rule says not to stress this word
  }
  let n = which > 0 ? which : syllables.length + which + 1;
  n = Math.min(n, syllables.length);
  n = Math.max(n, 1);

  // and finally add stress marker at start of proper syllable
  return addStress(word, syllables, n);
}

/** move existing stress markers */
function moveStress(word: IpaType[], move?: 'beforeVowel'): IpaType[] {
  const result: IpaType[] = [];
  for (let i = 0; i < word.length; i++) {
    const ph = word[i];
    let handled = false;

    if (isStress(ph)) {
      // if previous is a vowel, swap it with the stress marker
      const prevPh = word[i - 1];
      if (prevPh !== undefined && getFeaturesForOne(prevPh).includes('vowel')) {
        result[i - 1] = ph;
        result.push(prevPh);
        handled = true;
      }
    }

    if (!handled) {
      result.push(ph);
    }
  }
  return result;
}

function addStress(word: IpaType[], syllables: number[], n: number): IpaType[] {
  const newWord: IpaType[] = [];
  for (let syllable = 0, i = 0; syllable < syllables.length; syllable++) {
    if (syllable + 1 === n) {
      newWord.push(primaryStress);
    }
    // add all phonemes in this syllable
    for (let j = 0; j < syllables[syllable]; j++, i++) {
      newWord.push(word[i]);
    }
  }
  return newWord;
}
